import script from "./fw28_profile.vue?vue&type=script&setup=true&lang=js"
export * from "./fw28_profile.vue?vue&type=script&setup=true&lang=js"

import "./fw28_profile.vue?vue&type=style&index=0&id=523e6cb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-523e6cb2"]])

export default __exports__